<template>
    <div class="d-flex align-center mr-2">
        <div class="ml-4 text-h5 font-weight-light">
            Admin
        </div>
        <div class="flex-grow-1">
            <slot></slot>
        </div>
<!--Invoices Page-->
        <template v-if="$store.state.ref.admin.tabIndex === 2">
            <div style="width: 300px">
                <v-text-field
                        placeholder="Search"
                        hide-details
                        class="pa-0 ma-0 mx-2"
                        color="primary"
                        prepend-inner-icon="mdi-magnify"
                        solo
                        dense
                        v-model="$store.state.ref.admin.invoices.filterStr"
                ></v-text-field>
            </div>
        </template>
    </div>
</template>

<script>

export default {
    props: {
        shown: Boolean,
    },
    data() {
        return {
        }
    },
    watch: {
    },
    methods: {
    },
    computed: {
    },
}
</script>

<style scoped>

</style>